export const TEMPLATES_NAME_QUERY = `query templatesName {
  templates {
    id
    name
  }
}
`